const ZstdCodec = require('./lib/zstd-codec.js');

module.ZstdCodec = {};
module.exports.ZstdCodec = ZstdCodec;
